import { BaseScene } from './BaseScene';
import { SceneKey } from './sceneKeys';
import { GameMode } from '../types/GameMode';
import { GAME_WIDTH, GAME_HEIGHT } from './gameConfig';
import { deleteSurvivalSave, loadSurvivalBest, updateSurvivalBest } from '../utils/survivalManager';
import { playBgm, playSe } from '../utils/audioManager';
import { AudioKey } from '../constants/audioKeys';

/** SurvivalResultSceneに渡されるデータ */
export interface SurvivalResultSceneData {
  winCount: number;
  monsterId: string;
}

/**
 * サバイバルリザルト画面
 * 敗北時に連勝数・最高記録を表示する
 */
export class SurvivalResultScene extends BaseScene {
  constructor() {
    super(SceneKey.SURVIVAL_RESULT);
  }

  create(data?: SurvivalResultSceneData): void {
    playBgm(this.sound, AudioKey.BGM_RESULT_DEFEAT);
    playSe(this.sound, AudioKey.SE_DEFEAT);

    const winCount = data?.winCount ?? 0;
    const monsterId = data?.monsterId ?? '';
    const prevBest = loadSurvivalBest(monsterId);
    updateSurvivalBest(monsterId, winCount);
    const newBest = loadSurvivalBest(monsterId);
    const isNewRecord = winCount > prevBest;

    deleteSurvivalSave();

    this.setupOrientationPrompt();
    this.createUI(winCount, newBest, isNewRecord);
  }

  private createUI(winCount: number, best: number, isNewRecord: boolean): void {
    const cx = GAME_WIDTH / 2;

    this.add
      .text(cx, 70, 'サバイバル終了', { fontSize: '32px', color: '#ff4444' })
      .setOrigin(0.5);

    if (isNewRecord) {
      this.add
        .text(cx, 120, '🎉 新記録！', { fontSize: '24px', color: '#ffd700' })
        .setOrigin(0.5);
    }

    this.add
      .text(cx, 175, `連勝数: ${winCount}`, { fontSize: '28px', color: '#ffffff' })
      .setOrigin(0.5);

    this.add
      .text(cx, 220, `最高記録: ${best}`, { fontSize: '22px', color: '#ffffff', stroke: '#000000', strokeThickness: 4 })
      .setOrigin(0.5);

    this.createButton(cx, 310, 'もう一度（最初から）', () => {
      this.transitionTo(SceneKey.CHARACTER_SELECT, { mode: GameMode.SURVIVAL });
    });

    this.createButton(cx, 370, 'タイトルへ', () => {
      this.transitionTo(SceneKey.TITLE);
    });
  }

  private createButton(x: number, y: number, label: string, onClick: () => void): void {
    const btn = this.add
      .text(x, y, label, {
        fontSize: '22px',
        color: '#ffffff',
        backgroundColor: '#333333',
        padding: { x: 20, y: 10 },
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });
    btn.on('pointerdown', onClick);
    btn.on('pointerover', () => btn.setStyle({ color: '#ffff00' }));
    btn.on('pointerout', () => btn.setStyle({ color: '#ffffff' }));
  }
}
